import { render, staticRenderFns } from "./LoginByPhone.vue?vue&type=template&id=149a3fe4&lang=pug&"
import script from "./LoginByPhone.vue?vue&type=script&lang=ts&"
export * from "./LoginByPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports